// extracted by mini-css-extract-plugin
module.exports = {"ico":"ScrollInvoker_ico__fNzuv","pulse":"ScrollInvoker_pulse__W59Lq"};